import * as types from "../actions/actionTypes";
import { clampLyricSize, loadPreferences, savePreferences, THEMES, withSongKey } from "../lib/preferences";

const BOOLEANS = ["highContrast", "showChords", "keepAwake", "keepFavoritesOffline"];

export default function preferencesReducer(state = loadPreferences(), action) {
  switch (action.type) {
    case types.PREFERENCES_SET: {
      const next = { ...state };
      if (action.lyricSize !== undefined) next.lyricSize = clampLyricSize(action.lyricSize);
      if (action.theme !== undefined && THEMES.includes(action.theme)) next.theme = action.theme;
      for (const key of BOOLEANS) {
        if (action[key] !== undefined) next[key] = Boolean(action[key]);
      }
      savePreferences(next);
      return next;
    }

    case types.PREFERENCES_SET_SONG_KEY: {
      if (!Number.isInteger(action.songId) || action.songId <= 0) return state;
      const next = { ...state, songKeys: withSongKey(state.songKeys, action.songId, action.semitones) };
      savePreferences(next);
      return next;
    }

    default:
      return state;
  }
}
